<simple-card
  class="distribution-charts-container"
  [cardTitle]="'Portfolio distribution'"
  [showHeader]="true"
  [contentLayout]="'default'"
>
  <chart
    class="distribution-charts-chart"
    [ngClass]="isSidebarCollapsed ? 'collapsed' : 'expanded'"
    [field]="'therapeuticArea'"
    [chartTitle]="therapeuticAreaChartTitle"
    [sortedData]="sortedTherapeuticAreaData"
    [chartOption]="barTruncated"
    [expandedView]="true"
    [initOption]="small"
    [showAllKeys]="true"
    [enableScroll]="true"
    [scrollVisibleItems]="5"
    (expandRequested)="onExpandRequested()"
  ></chart>
  <chart
    class="distribution-charts-chart"
    [ngClass]="isSidebarCollapsed ? 'collapsed' : 'expanded'"
    [field]="'studyPhase'"
    [chartTitle]="phaseChartTitle"
    [sortedData]="sortedPhaseData"
    [chartOption]="bar"
    [initOption]="small"
    [showAllKeys]="true"
  ></chart>
  <chart
    class="distribution-charts-chart"
    [ngClass]="isSidebarCollapsed ? 'collapsed' : 'expanded'"
    [field]="'studyStage'"
    [chartTitle]="stageChartTitle"
    [sortedData]="sortedStageData"
    [chartOption]="bar"
    [initOption]="small"
    [showAllKeys]="true"
  ></chart>
  <chart
    class="distribution-charts-chart"
    [ngClass]="isSidebarCollapsed ? 'collapsed' : 'expanded'"
    [field]="'accelerator'"
    [chartTitle]="acceleratorChartTitle"
    [sortedData]="sortedAcceleratorData"
    [chartOption]="pie"
    [colorMap]="colorMap"
    [initOption]="small"
    [showAllKeys]="false"
  ></chart>
</simple-card>
